import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import { useI18n } from '@newtontechnologies/applib-frontend';
import SubtitleModal from './SubtitleModal';
const DownloadSubtitles = ({ task, isReady }) => {
    const { intl } = useI18n();
    const [subtitleModalVisible, setSubtitleModalVisible] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: intl.formatMessage({ id: 'downloadSubtitles' }), children: _jsx(Button, { className: "task-btn", disabled: !isReady, shape: "circle", icon: _jsx(CommentOutlined, {}), onClick: () => setSubtitleModalVisible(true) }) }), _jsx(SubtitleModal, { visible: subtitleModalVisible, onCancel: () => setSubtitleModalVisible(false), onOk: () => setSubtitleModalVisible(false), task: task })] }));
};
export default DownloadSubtitles;
